import React from "react";
import { CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Lock, Copy } from "lucide-react";
import { userBankDetails } from "../data/mockTradeRates";
import { Table, TableBody, TableCell, TableRow } from "./ui/table";

export default function ReceiveForex({ onDeposit, bank, refCode }) {
  const referenceCode = userBankDetails?.refCode;

  const bankDetails = [
    { label: "Recipient", value: userBankDetails?.receipient },
    { label: "Bank", value: userBankDetails?.bank },
    { label: "Account Number", value: userBankDetails?.accountNumber },
    { label: "Branch Code", value: userBankDetails?.branchCode },
    { label: "SWIFT Code", value: userBankDetails?.swift },
    { label: "Reference", value: userBankDetails?.refCode },
  ].filter(({ label, value }) => {
    if (label === "SWIFT Code") return !!value;
    return true;
  });

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };

  return (
    <CardContent>
      <h2 className="text-xl font-semibold text-purple-600 mb-3">
        Receive an international payment
      </h2>
      <p className="text-sm text-gray-600 mb-5">
        Share the details below with the person sending you money, using your
        Forex reference number as the beneficiary reference
      </p>

      <div className="mb-3">
        <button
          type="button"
          className="text-sm font-medium text-rose-600 hover:underline"
          onClick={() => alert("Explain how this works...")}
        >
          How does this work?
        </button>
      </div>

      <p className="text-sm font-medium text-gray-700 mb-2">
        80eight forex reference
      </p>
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-rose-100 text-rose-700 px-4 py-2 rounded-lg font-semibold text-md">
          {referenceCode}
        </div>
        <button
          onClick={() => handleCopy(referenceCode)}
          className="inline-flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
        >
          <Copy size={16} />
        </button>
      </div>

      <p className="text-sm font-medium text-gray-700 mb-3">
        Bank transfer details
      </p>
      <div className="overflow-hidden rounded-lg border border-gray-200 mb-6">
        <Table className="w-full bg-white">
          <TableBody>
            {bankDetails.map(({ label, value }) => (
              <TableRow
                key={label}
                className="flex items-center justify-between"
              >
                <TableCell className="font-semibold text-sm text-gray-600 py-3">
                  {label}
                </TableCell>
                <TableCell className="text-sm text-gray-700 flex items-center gap-2">
                  {value}
                  {label !== "Account Type" &&
                    label !== "Reference" &&
                    value && (
                      <button
                        onClick={() => handleCopy(value)}
                        className="inline-flex items-center justify-center w-7 h-7 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                      >
                        <Copy size={16} />
                      </button>
                    )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="bg-gray-50 border border-gray-100 rounded-lg p-3 text-sm text-blue-600 mb-6">
        <p>Your ZAR wallet will update in 2-3 days.</p>
      </div>

      <Button
        className="w-full py-4 h-15 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold"
        onClick={() => {
          if (onDeposit) {
            onDeposit();
          }
        }}
      >
        Share details
      </Button>

      <div className="text-center text-sm text-gray-500 mt-6 flex items-center justify-center">
        <Lock size={10} className="mr-2" />
        <p>Secured by 80eight</p>
      </div>
    </CardContent>
  );
}
